import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { FDSecondaryActionButton } from '@facet-wealth/design';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: `${theme.spacing(1)}px`,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
}));

function ActionItemsHeader({
  getTaskCollection,
  showHidden,
}) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <FDSecondaryActionButton
        onClick={() => {
          getTaskCollection(!showHidden);
        }}
        label={showHidden ? 'Show Active' : 'Show Hidden'}
        size="sm"
      />
      <FDSecondaryActionButton
        onClick={() => openModal(modalConsts.clientActionItemModal)}
        icon="add"
        label={'Add Action'}
        size="sm"
      />
    </Box>
  );
}

ActionItemsHeader.propTypes = {
  showHidden: PropTypes.bool.isRequired,
  getTaskCollection: PropTypes.func.isRequired,
};

export default ActionItemsHeader;
